import { useProcessStepRecording } from '@/api/queries/useRecording';
import { useProcess } from '@/api/queries/useProcesses';

/**
 * A recording's parent process. `useProcessStepRecording` returns a minimal
 * recording; the process returns each step as `ProcessStepRecordingDisplay`.
 * A known process id skips the recording fetch.
 */
export function useRecordingProcess(recordingId: string, knownProcessId?: string) {
  const recordingQuery = useProcessStepRecording(knownProcessId ? '' : recordingId);
  const recordingResponse = recordingQuery.data;
  const processIdFromRecording =
    recordingResponse && 'processStepRecording' in recordingResponse
      ? recordingResponse.processStepRecording.process
      : '';
  const processQuery = useProcess(knownProcessId || processIdFromRecording);
  const recordingWithoutStep =
    recordingResponse !== undefined && !('processStepRecording' in recordingResponse);

  return { recordingQuery, processQuery, recordingWithoutStep };
}
